import { Box, Button, Stack, TextField } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { DialogPlanLlmPrompt } from '../../api/DialogPlanLlmPromptApi';
import { DialogPromptSpeakWithGrade } from '../../api/DialogPromptApi';
import AppBarContext from '../../context/AppBarContext';
import { useSentenceChinesePinyin } from '../../hook/useSentenceChinesePinyin';
import { useStudentResponsePinyin } from '../../hook/useStudentResponsePinyin';

interface DialogPlanLlmPromptSpeakWithGradeGeneratedProps {
    dialogPrompt?: DialogPromptSpeakWithGrade; // if llmPrompt was generated
    onSubmit?: (updatedDialogPlanLlmPrompt: DialogPlanLlmPrompt, setIsSaving: React.Dispatch<React.SetStateAction<boolean>>) => void;
    onDelete?: (dialogPlanLlmPromptId: number) => void;

    isRegenerating?: boolean;
    handleLlmPromptChange?: (dialogPlanLlmPrompt: DialogPlanLlmPrompt) => void;
    handleRegenerateDialogPlanLlmPrompt?: (dialogPlanLlmPrompt: DialogPlanLlmPrompt, fieldName: string) => void;
}

const DialogPlanLlmPromptSpeakWithGradeGenerated: React.FC<DialogPlanLlmPromptSpeakWithGradeGeneratedProps> = ({ dialogPrompt }) => {

    const { setErrorMessage } = React.useContext(AppBarContext)
    const history = useHistory();
    const location = useLocation();

    // const [teacherChinesePrompt, setTeacherChinesePrompt] = React.useState("");
    const {
        text: teacherChinesePrompt,
        pinyin: teacherChinesePromptPinyin,
        pinyinList: teacherChinesePromptPinyinList,
        pinyinErrorText: teacherChinesePromptPinyinErrorText,
        setDialogPromptFields: setTeacherChinesePromptields,
        clearErrorText: clearTeacherChinesePromptErrorText,
        handleTextChange: handleTeacherChinesePromptChange,
        handlePinyinChange: handleTeacherChinesePromptPinyinChange,
    } = useSentenceChinesePinyin({ history, location, setErrorMessage });
    const [teacherHintPrompt, setTeacherHintPrompt] = React.useState("");
    // const [studentResponsePrompt, setStudentResponsePrompt] = React.useState("<Answer/>");
    // const [studentResponseList, setStudentResponseList] = React.useState("");
    const {
        studentResponsePrompt,
        studentResponseList,
        studentResponseListErrorText,
        studentResponsePinyinList,
        studentResponsePinyinErrorText,
        setStudentResponseFields,
        handleStudentResponsePromptChange,
        handleStudentResponseListChange,
        handleStudentResponsePinyinListChange,
    } = useStudentResponsePinyin({ history, location, setErrorMessage });

    const setDialogPromptFields = React.useCallback((dialogPrompt: DialogPromptSpeakWithGrade) => {
        // setTeacherChinesePrompt(dialogPrompt.teacher_chinese_prompt ? dialogPrompt.teacher_chinese_prompt : "")
        setTeacherChinesePromptields(dialogPrompt.teacher_chinese_prompt, dialogPrompt.teacher_chinese_prompt_pinyin, dialogPrompt.teacher_chinese_prompt_sentence_id)
        // setStudentResponsePrompt(dialogPrompt.student_response_prompt ? dialogPrompt.student_response_prompt : "")
        setStudentResponseFields(dialogPrompt.student_response_prompt, dialogPrompt.dialog_prompt_sentence_list)
        setTeacherHintPrompt(dialogPrompt.teacher_hint_prompt ? dialogPrompt.teacher_hint_prompt : "")
        // setStudentResponseList(dialogPrompt.dialog_prompt_sentence_list
        //     ? dialogPrompt.dialog_prompt_sentence_list
        //         .map(item => item.student_response)
        //         .join("\n") // Convert array to newline-separated string
        //     : ""
        // )
    }, [setTeacherChinesePromptields, setStudentResponseFields, setTeacherHintPrompt])

    React.useEffect(() => {
        if (dialogPrompt) {
            setDialogPromptFields(dialogPrompt);
            clearTeacherChinesePromptErrorText();
        }
    }, [clearTeacherChinesePromptErrorText, dialogPrompt, setDialogPromptFields])

    React.useEffect(() => {
        if (dialogPrompt) dialogPrompt.teacher_chinese_prompt = teacherChinesePrompt;
    }, [teacherChinesePrompt, dialogPrompt])

    React.useEffect(() => {
        if (dialogPrompt) dialogPrompt.teacher_chinese_prompt_pinyin = teacherChinesePromptPinyinList;
    }, [teacherChinesePromptPinyinList, dialogPrompt])



    // update dialog prompt
    // const handleTeacherChinesePromptChange = (e: React.ChangeEvent<HTMLInputElement>) => { setTeacherChinesePrompt(e.target.value); if (dialogPrompt) dialogPrompt.teacher_chinese_prompt = e.target.value };
    // const handleStudentResponsePromptChange = (e: React.ChangeEvent<HTMLInputElement>) => { setStudentResponsePrompt(e.target.value); if (dialogPrompt) dialogPrompt.student_response_prompt = e.target.value };
    const handleTeacherHintPromptChange = (e: React.ChangeEvent<HTMLInputElement>) => { setTeacherHintPrompt(e.target.value); if (dialogPrompt) dialogPrompt.teacher_hint_prompt = e.target.value };
    const handleStudentResponsePromptChangeWithDialogPrompt = (e: React.ChangeEvent<HTMLInputElement>) => { handleStudentResponsePromptChange(e); if (dialogPrompt) dialogPrompt.student_response_prompt = e.target.value };
    // const handleStudentResponseListChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const responseListString = e.target.value
    //     setStudentResponseList(responseListString);
    //     if (dialogPrompt) {
    //         const lines = responseListString.split("\n").filter(line => line.trim() !== "");

    //         // Map each line to an IDialogPromptSentence object
    //         dialogPrompt.dialog_prompt_sentence_list = lines.map((studentResponse, index) => ({
    //             id: 0, // Assuming `id` is generated by the backend
    //             dialog_prompt_id: dialogPrompt.id, // Use the provided dialogPromptId
    //             sentence_id: 0, // Assuming this is set later or generated by the backend
    //             student_response: studentResponse.trim(), // Assign the trimmed response
    //             order_index: index + 1, // Incremental order based on line position
    //         }));
    //     }
    // };

    return (<>
        <Stack spacing={4} sx={{ width: '100%', margin: '0 auto', pt: 2, pb: 4 }}>
            <TextField
                label="Teacher Chinese Prompt"
                value={teacherChinesePrompt}
                onChange={handleTeacherChinesePromptChange}
                multiline
                rows={5}
            />
            <TextField
                label="Teacher Chinese Prompt Pinyin"
                value={teacherChinesePromptPinyin}
                onChange={handleTeacherChinesePromptPinyinChange}
                required
                error={teacherChinesePromptPinyinErrorText != null}
                helperText={teacherChinesePromptPinyinErrorText}
            />
            {/* Hidden spacer button */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button variant="contained"
                    disabled={true}
                    sx={{ opacity: 0 }}
                >
                    Regenerate
                </Button>
            </Box>
            <div>
                <TextField
                    label="Student Chinese Prompt"
                    value={studentResponsePrompt ? studentResponsePrompt : "<Answer/>"}
                    onChange={handleStudentResponsePromptChangeWithDialogPrompt}
                    required
                    sx={{ width: '100%' }}
                    multiline
                    rows={5}
                />
                <Typography sx={{ color: 'grey.500', fontSize: '0.9rem' }}>
                    Use &lt;Answer/&gt; to mark where the response is inserted
                </Typography>
                {/* Hidden spacer button */}
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Button variant="contained"
                        disabled={true}
                        sx={{ opacity: 0 }}
                    >
                        Regenerate
                    </Button>
                </Box>
            </div>
            <TextField
                label="Teacher Hint Prompt"
                value={teacherHintPrompt}
                onChange={handleTeacherHintPromptChange}
                multiline
                rows={5}
            />
            {/* Hidden spacer button */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button variant="contained"
                    disabled={true}
                    sx={{ opacity: 0 }}
                >
                    Regenerate
                </Button>
            </Box>
            <TextField
                label="Allowed Student Prompt Responses"
                value={studentResponseList}
                onChange={handleStudentResponseListChange} // just store value on change
                onBlur={handleStudentResponseListChange} // full processing logic goes here
                multiline
                rows={5}
                sx={{ width: '100%' }}
                required
                error={studentResponseListErrorText != null}
                helperText={studentResponseListErrorText}
            />
            <TextField
                label="Allowed Student Prompt Response Pinyin"
                value={studentResponsePinyinList}
                onChange={handleStudentResponsePinyinListChange}
                multiline
                rows={6}
                sx={{ width: '100%' }}
                required
                error={studentResponsePinyinErrorText != null}
                helperText={studentResponsePinyinErrorText}
            />
            {/* Hidden spacer button */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button variant="contained"
                    disabled={true}
                    sx={{ opacity: 0 }}
                >
                    Regenerate
                </Button>
            </Box>
        </Stack>
    </>);
};

export default DialogPlanLlmPromptSpeakWithGradeGenerated;